<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-timeline-text</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.timeline') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;" /> -->
    </v-toolbar>
    <v-checkbox
      v-show="!collapseContent"
      v-model="content.HideHeader"
      :label="$t('timeline.hideHeader')"
    />
    <v-checkbox
      v-show="!collapseContent"
      v-if="!content.HideHeader"
      v-model="content.IsHeaderText"
      :label="$t('timeline.isTextHeader')"
    />
    <translate
      v-show="!collapseContent"
      v-if="!content.HideHeader && content.IsHeaderText"
      v-model="content.TimeLineTextHeader"
      :languages="languages"
      :label="$t('timeline.textHeader')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <translate
      v-show="!collapseContent"
      v-if="!content.HideHeader && content.IsHeaderText"
      v-model="content.TimeLineSubTextHeader"
      :languages="languages"
      :label="$t('timeline.subtextHeader')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <v-dialog
      v-if="!content.HideHeader && !content.IsHeaderText"
      v-show="!collapseContent"
      ref="dialogDate"
      v-model="modalDate"
      :return-value.sync="content.TimelineDate"
      persistent
      full-width
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-show="!collapseContent"
          v-model="content.TimelineDate"
          :label="$t('menus.availability.startDate')"
          prepend-icon="mdi-calendar-clock"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="content.TimelineDate"
        :locale="locale"
        scrollable
        dark
        @input="handleChangeIsModified"
      >
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="modalDate = false"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.dialogDate.save(content.TimelineDate)"
        >
          {{ $t('common.ok') }}
        </v-btn>
      </v-date-picker>
    </v-dialog>
    <select-image
      v-if="!content.HideHeader"
      v-show="!collapseContent"
      v-model="content.TimelineImage"
      :isFullWidth="true"
      :enterpriseID="enterpriseID"
      :imageOld='content.TimelineImage'
      @input="handleChangeIsModified"
      style="margin: 15px 0 20px 0;"
    />
    <br v-show="!collapseContent">
    <v-btn
      v-show="!collapseContent"
      dark
      block
      @click="handleAddTime"
      :color="enterpriseColor"
    >
      <v-icon>mdi-plus</v-icon>{{ $t('timeline.addEvent') }}
    </v-btn>
    <v-timeline
      v-if="!collapseContent"
      align-top
      dense
    >
    <timeline-item
      v-for="(time, index) in content.Times"
      :key="`time${index}`"
      :time="time"
      :onDelete="handleDelete"
    />
      <!-- <v-timeline-item
        v-for="(time, index) in content.Times"
        :key="`time${index}`"
        :color="time.Color"
        icon="mdi-clock-outline"
        small
      >
        <v-row class="pt-1">
          <v-col cols="3">
            <custom-time-picker
              v-model="time.Time"
              @input="handleChangeTime"
            />
            <custom-color-picker
              :color="time.Color"
              :onChangeColor="handleChangeColor"
            />
          </v-col>
          <v-col>
            <translate
              v-model="time.Title"
              :languages="['es', 'en']"
              :label="$t('timeline.title')"
              @input="handleChangeIsModified"
              style="padding: 0 10px 0 10px;"
            />
            <translate
              v-model="time.Description"
              type="textArea"
              :languages="['es', 'en']"
              :label="$t('timeline.description')"
              @input="handleChangeIsModified"
              style="padding: 0 10px 0 10px;"
            />
          </v-col>
        </v-row>
      </v-timeline-item> -->
    </v-timeline>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import _ from 'lodash'
  import TimelineItem from './TimelineItem'
  import SelectImage from '@/components/SelectImage'
  import Translate from '@/components/Translate'
  export default {
    components: {
      TimelineItem,
      SelectImage,
      Translate
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      modalDate: false
    }),
    computed: {
      ...mapState('app',['locale','collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      languages () {
        return this.$store.state.app.Languages
      }
    },
    methods: {
      handleDelete (id) {
        this.content.Times = this.content.Times.filter(x => x.ID !== id)
      },
      handleAddTime () {
        this.handleChangeIsModified()
        this.content.Times.push({
          ID: `new_${_.uniqueId()}`,
          Time: '12:00',
          Title: { es: '' },
          Description: { es: ''},
          Color: '#e91e63'
        })
      },
      handleChangeTime () {
        this.handleChangeIsModified()
      },
      handleChangeColor () {
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

